module.exports = __webpack_public_path__ + "img/sulphite.3b480acf.svg";